import React from 'react';
import { IoMdStar } from 'react-icons/io';
import { BsImageFill } from 'react-icons/bs';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './PinnedPreview.scss';

const PinnedPreview = props => {
	const { color, isPad, from, padding, margin, includeHeaders } = props;
	const fromButton = from === 'WidgetButton';
	const fromPreview = from === 'Preview';
	// Pinned Announcement below
	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Pinned Items</div>}
				<div className="column-container" style={{ margin }}>
					{!fromButton && includeHeaders && (
						<div className="divider">
							<div className="line" style={{ backgroundColor: color }}></div>
							<h3 style={{ color }}>Pinned</h3>
							<div className="line" style={{ backgroundColor: color }}></div>
						</div>
					)}
					<div
						className="pinnedItem"
						style={{
							padding,
							marginBottom: fromButton || fromPreview ? 0 : '1em',
							cursor: fromPreview ? 'default' : 'pointer',
						}}
					>
						<div
							className="pinnedItem-icon"
							style={{ marginRight: fromButton || fromPreview ? '1em' : isPad ? '2em' : '1.5em' }}
						>
							<IoMdStar style={{ fontSize: fromButton || fromPreview ? 28 : 36, color }} />
						</div>
						<div className="pinnedItem-info">
							<div
								className="pinnedItem-title"
								style={{
									backgroundColor: color,
									height: fromButton ? '.7em' : fromPreview ? '.8em' : '1em',
								}}
							></div>
							<div
								className="pinnedItem-body"
								style={{ height: fromButton ? '.5em' : fromPreview ? '.8em' : '.9em' }}
							></div>
							<div
								className="pinnedItem-time"
								style={{ height: fromButton ? '.4em' : fromPreview ? '.5em' : '.6em' }}
							></div>
						</div>
					</div>
					{/* Pinned Social below */}
					{!fromButton && !fromPreview && (
						<div className="pinnedItem" style={{ padding }}>
							<div className="pinnedImg">
								<BsImageFill style={{ fontSize: 28, color: 'white' }} />
							</div>
							<div className="pinnedItem-info">
								<div className="pinnedItem-header">
									<div className="pinnedItem-attendee">
										<Avatar icon={<UserOutlined />} style={{ marginRight: '10px' }} />
										<div className="attendee-header">
											<div
												className="pinnedItem-attendee-name"
												style={{ backgroundColor: color }}
											></div>
											<div className="pinnedItem-time"></div>
										</div>
									</div>
									<div className="pinnedItem-icon">
										<IoMdStar style={{ fontSize: 32, color }} />
									</div>
								</div>
								<div className="pinnedItem-body"></div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default PinnedPreview;
